import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";

interface VisitRequestStatus {
  id: string;
  display_name: string;
}

export function VisitRequestStatusHandbook(
  props: AutocompleteProps<VisitRequestStatus>,
) {
  const items: VisitRequestStatus[] = [
    { id: "new", display_name: "Новая" },
    { id: "progress", display_name: "В процессе" },
    { id: "done", display_name: "Выполнена" },
    { id: "close", display_name: "Закрыта" },
  ];

  return (
    <Autocomplete
      defaultItems={items}
      label="Статус заявки"
      placeholder="Выберите статус заявки"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={item.id}>{item.display_name}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
